import apiService from "../ApiService";

const endpoint = "/institutions";

/**
 * Get all institutions
 * Optional filters:
 * ?stateCode=KA
 * ?districtName=Udupi
 * ?level=ug
 * ?type=Govt
 * ?search=college
 */
export const getInstitutions = async (params = {}) => {
    try {
        const queryString = new URLSearchParams(params).toString();
        const url = queryString ? `${endpoint}?${queryString}` : endpoint;

        const response = await apiService.getAll(url);
        return response;
    } catch (error) {
        console.error("Error fetching institutions:", error);
        throw error;
    }
};

/**
 * Get institution by ID
 */
export const getInstitutionById = async (id) => {
    try {
        const response = await apiService.getById(endpoint, id);
        return response;
    } catch (error) {
        console.error(`Error fetching institution with ID ${id}:`, error);
        throw error;
    }
};

/**
 * Create institution
 */
export const createInstitution = async (data) => {
    try {
        const response = await apiService.create(endpoint, data);
        return response;
    } catch (error) {
        console.error("Error creating institution:", error);
        throw error;
    }
};

/**
 * Update institution
 */
export const updateInstitution = async (id, data) => {
    try {
        const response = await apiService.update(endpoint, id, data);
        return response;
    } catch (error) {
        console.error("Error updating institution:", error);
        throw error;
    }
};

/**
 * Delete institution
 */
export const deleteInstitution = async (id) => {
    try {
        const response = await apiService.remove(endpoint, id);
        return response;
    } catch (error) {
        console.error("Error deleting institution:", error);
        throw error;
    }
};
/**
 * Import institutions from file
 */
export const importInstitutions = async (formData) => {
    try {
        const response = await apiService.post(`${endpoint}/import`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        return response;
    } catch (error) {
        console.error("Error importing institutions:", error);
        throw error;
    }
};

/**
 * Download institution template
 */
export const downloadTemplate = async () => {
    try {
        const response = await apiService.get(`${endpoint}/template`, {
            responseType: "blob"
        });

        // Response is the blob itself because apiService.get returns response.data
        const blob = new Blob([response], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Institution_Template.xlsx");
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);

        return true;
    } catch (error) {
        console.error("Error downloading template:", error);
        throw error;
    }
};
